import { COMPLIANCE_URL } from '@constants/app-constants';
import ERRORS from '../globals/errorConstants'
import Axios from 'axios';

class ComplianceService {
	baseUrl = `${COMPLIANCE_URL}/client/violation-resolution`;

	async createViolationResolution(formData) {
		return Axios.post(`${this.baseUrl}/create`, formData, {
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		});
	}

	async getComplianceCase(complianceCaseId) {
		return Axios.get(`${this.baseUrl}/details/${complianceCaseId}`).then(response =>
			response.data
		).catch(e => {
			if (e.name === ERRORS.NOT_FOUND.name) {
				return {
					code: '404',
					message: e.message,
					data: null
				}
			}
		});
	}

	async getJustificationOptions() {
		return Axios.get(`${COMPLIANCE_URL}/justification`).then(response =>
			response.data.data
		);
	}

	async rfiUpdate(formData) {
		return Axios.post(`${this.baseUrl}/RFI`, formData, {
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		});
	}

	async downloadDocument(documentId) {
		return Axios.get(`${COMPLIANCE_URL}/document/client/${documentId}`, {
			responseType: 'blob',
		});
	}
}

export default ComplianceService;